import {InjectionToken} from '@angular/core';

export const TEXT_ACT = new InjectionToken('#im-ng/text/act');